import React, { useState } from 'react';
import { Box, Typography, Stack, Paper, Button } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

// Data for the filter buttons
const filters = [
  { id: 'waiting', label: 'Waiting on TA', count: 0 },
  { id: 'replied', label: 'Replied by TA', count: 0 },
  { id: 'resolved', label: 'Resolved', count: 0 },
  { id: 'pool', label: 'Move to open pool', count: 0 },
];

// A custom component for the filter buttons to keep the main component clean
const FilterButton = ({ label, count, active, onClick }) => {
  const isSelected = active;
  
  return (
    <Button
      onClick={onClick}
      variant={isSelected ? "contained" : "outlined"}
      sx={{
        textTransform: 'none',
        borderRadius: '12px',
        py: 1.5,
        px: 2.5,
        justifyContent: 'space-between',
        gap: 3,
        fontWeight: 500,
        borderColor: isSelected ? 'primary.main' : 'border.grey',
        color: isSelected ? 'white.main' : 'secondary.light',
        bgcolor: isSelected ? 'primary.main' : 'white.main',
        '&:hover': {
          bgcolor: isSelected ? 'primary.dark' : '#f8f9fa',
          borderColor: 'border.grey',
        },
      }}
    >
      {label}
      <Box
        component="span"
        sx={{
          border: '1.5px solid',
          borderColor: isSelected ? 'white.main' : 'primary.main',
          color: isSelected ? 'white.main' : 'primary.main',
          borderRadius: '6px',
          px: '10px',
          py: '2px',
          fontSize: '0.875rem',
          lineHeight: 1.5,
        }}
      >
        {count}
      </Box>
    </Button>
  );
};


const HelpRequestsPage = () => {
  // Set the default active filter based on the image
  const [activeFilter, setActiveFilter] = useState('replied');

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'background.paper' }}>
      <Stack spacing={3}>
        
        {/* Filter Buttons Section */}
        <Stack direction="row" spacing={2} sx={{ overflowX: 'auto', pb: 1 }}>
          {filters.map((filter) => (
            <FilterButton
              key={filter.id}
              label={filter.label}
              count={filter.count}
              active={activeFilter === filter.id}
              onClick={() => setActiveFilter(filter.id)}
            />
          ))}
        </Stack>
        
        {/* Information Banner */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            bgcolor: 'background.default',
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <AccessTime sx={{ color: 'error.main' }} />
          <Typography variant="body1" color="secondary.light">
            Requests will be marked resolved if you don't take any action. Check the time frame of a request for accurate details.
          </Typography>
        </Paper>

        {/* Empty State Content Area */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '40vh',
          }}
        >
          <Typography variant="body1" color="text.secondary">
            No Help Requests fit the search criteria.
          </Typography>
        </Box>

      </Stack>
    </Box>
  );
};

export default HelpRequestsPage;